import { Component, OnInit, ViewEncapsulation, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { AppEventDispatcher } from './../../../utils/AppEventDispatcher';
import { EventTypes } from '../../../shared/EventTypes';
import { DepositEventType } from './../deposit-per-ticket.event.type';
import { TweenMax, Quint } from 'gsap';
import { Deposit } from './../models/deposit';

@Component({
	selector: 'app-deposit-result',
	templateUrl: './deposit-result.component.html',
	styleUrls: ['./deposit-result.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class DepositResultComponent implements OnInit, OnDestroy {

	@Input() flow: string;
	@Input() submited = false;
	@Input() depositData: Deposit;

	@Output() setTitleSubtitle: EventEmitter<any> = new EventEmitter<any>();

	private view = '[data-component="deposit-result"]';

	active = false;

	constructor() { }

	ngOnInit() {
		AppEventDispatcher.listen(
			DepositEventType.STEPS.DEPOSIT_RESULT,
			data => {
				if (data.show) {
					this.active = true;
					this.show();
				} else {
					this.hide();
				}
			}
		);
	}

	ngOnDestroy() {
		AppEventDispatcher.removeListener(DepositEventType.STEPS.DEPOSIT_RESULT);
	}

	show() {

		this.setTitleSubtitle.emit({
			title: 'Resumo do Depósito por boleto',
			subtitle: 'Transferência de valores para sua Conta Corrente.'
		});

		AppEventDispatcher.dispatch(DepositEventType.BUTTONS, {
			show: false
		});

		const interval = setInterval(() => {
			if ($(this.view).length > 0) {
				const containerHeight = this.getStepHeight();

				TweenMax.to('.steps-container', 0.8, {
					height: containerHeight,
					ease: Quint.easeOut
				});
				TweenMax.to(this.view, 0.8, {
					delay: 0.4,
					left: 0,
					ease: Quint.easeOut
				});

				clearInterval(interval);
			}
		}, 10);

		TweenMax.delayedCall(.5, () => {
			const containerHeight = this.getStepHeight();

			TweenMax.to('.steps-container', .8, { height: containerHeight, ease: Quint.easeOut});
			TweenMax.to(this.view, .8, { delay: .4, left: 0, ease: Quint.easeOut});


			AppEventDispatcher.dispatch(EventTypes.EXPORT_BUTTONS.DATA_TRANSACTION, {
				numberBankSlip: this.depositData.numberBankSlip
			});
		});
	}

	getStepHeight(): number {
		return $(this.view).outerHeight() + $('.buttons').outerHeight() + 60;
	}

	hide() {
		TweenMax.to(this.view, 2.8, {
			left: '-100%',
			ease: Quint.easeOut,
			onComplete: () => {
				this.active = false;
			}
		});
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/deposit-per-ticket/deposit-result/deposit-result.component.ts